<template>
  <AsyncPage
    :loader="useTransactionDetailLoader"
    :page-component="TransactionDetail"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useTransactionDetailLoader } from "./TransactionDetail.loader.ts";
import { transaction_detail as strings } from "./TransactionDetail.strings.ts";
import { AsyncPage } from "@saflib/vue/components";
import { useAsyncPageDocumentTitle } from "@saflib/vue";

useAsyncPageDocumentTitle(strings.documentTitle);

const TransactionDetail = defineAsyncComponent(
  () => import("./TransactionDetail.vue"),
);
</script>
